var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hl-Modal',{attrs:{"iconClass":"budicon-cloud-server text-danger"}},[_c('p',{staticClass:"mt-0 mb-5 text-danger"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }